import React from 'react'
// import { Link } from 'react-router-dom';
import PropTypes from 'prop-types'
import Alert from './Alert';
export default function Navbar(props) {

    return (
        <>
            <nav className={`navbar navbar-expand-lg background-color-unset navbar-${props.mode} bg-${props.mode}`}>
                <div className="container-fluid">
                    <h1 className={`fw-bold m-0 ${props.mode === 'light' ? 'text-dark' : 'text-light'} `} >{props.title}</h1>
                    <div>
                        <img style={{ filter: props.mode === 'light' ? '' : 'invert(1)' }} src={process.env.PUBLIC_URL + '/assets/images/logo/logo512.png'} alt="Logo" width={'60px'} />
                    </div>

                </div>
            </nav>
            <hr className='m-2' />
            <div className='d-flex justify-content-between align-items-center ' style={{height : '80px'}}>
                <div>
                <Alert alert={props.alert} setAlert={props.setAlert}/>
                </div>
                <div className={`form-check form-switch text-${props.mode === 'light' ? 'Dark' : 'light'}`}>
                    <input className="form-check-input" onChange={props.toogleMode} checked={props.mode === 'dark'} type="checkbox" id="flexSwitchCheckDefault" />
                    <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Enable {props.mode === 'light' ? 'Dark' : 'Light'}Mode </label>
                </div>
            </div>
        </>
    )
}

Navbar.propTypes = {
    title: PropTypes.string.isRequired,
    abouttext: PropTypes.string,
    mode: PropTypes.string.isRequired,
    toogleMode: PropTypes.func.isRequired,
    alert: PropTypes.object
  };
  
  Navbar.defaultProps = {
    title: "Default App Name",
    abouttext: "Default About Text",
    mode: "light",
    toogleMode: () => {},
    alert: null
  };
  